import React, { FC, ReactNode, memo } from 'react';

import Typography from '@mui/material/Typography';
import Theme from '@src/theme';

import highIcon from '@assets/vaults/riskLevel/high.svg?url';
import lowIcon from '@assets/vaults/riskLevel/low.svg?url';
import mediumIcon from '@assets/vaults/riskLevel/medium.svg?url';
import veryHighIcon from '@assets/vaults/riskLevel/very-hight.svg?url';
import veryLowIcon from '@assets/vaults/riskLevel/very-low.svg?url';

import { RiskLevel } from '@constants/vaults/vault.constants';

import useStyles from './styles.module';

interface Props {
  value: RiskLevel;
  className?: string;
  withLabel?: boolean;
}

interface RiskItem {
  title: string;
  color: string | undefined;
  icon: ReactNode;
}

const riskLevelInfo: Record<RiskLevel, RiskItem> = {
  [RiskLevel.VERY_LOW]: {
    title: 'Very low',
    color: '#91A2AF',
    icon: <img src={veryLowIcon} alt="" />,
  },
  [RiskLevel.LOW]: {
    title: 'Low',
    color: Theme.accent.a1,
    icon: <img src={lowIcon} alt="" />,
  },
  [RiskLevel.MEDIUM]: {
    title: 'Medium',
    color: '#F2F61D',
    icon: <img src={mediumIcon} alt="" />,
  },
  [RiskLevel.HIGH]: {
    title: 'High',
    color: Theme.accent.a4,
    icon: <img src={highIcon} alt="" />,
  },
  [RiskLevel.VERY_HIGH]: {
    title: 'Very high',
    color: Theme.accent.a6,
    icon: <img src={veryHighIcon} alt="" />,
  },
};

const RiskLeveler: FC<Props> = ({
  value,
  className = '',
  withLabel = false,
}) => {
  const { classes, cx } = useStyles();

  const { title, color, icon } = riskLevelInfo[value || RiskLevel.VERY_LOW];

  return (
    <div className={cx(classes.container, className)}>
      {withLabel && (
        <Typography variant="caption" style={{ color }}>
          {title}
        </Typography>
      )}
      {icon}
    </div>
  );
};

export default memo(RiskLeveler);
